/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import axios from 'axios';
import { IRequestContext, msdyn365Commerce } from '@msdyn365-commerce/core-internal';
import { IInternalTelemetry, LogLevel } from '@msdyn365-commerce/telemetry-internal';

interface ISegmentProvider {
    providerId: string;
    segmentIds: string[];
}

export const resolveMissingSegmentsOnClient = (requestContext: IRequestContext, userId: string, telemetry: IInternalTelemetry) => {
    if (!requestContext || !requestContext.missingSegments || requestContext.missingSegments.length) {
        return;
    }
    let domain = requestContext.canonicalDomain || '';
    if (msdyn365Commerce.isBrowser) {
        domain = window.location.hostname;
    }
    const missingSegments: ISegmentProvider[] = [];
    const neededMissingSegments = requestContext.missingSegments;
    Object.keys(neededMissingSegments).forEach((providerId: string) => {
        const segmentProvider: ISegmentProvider = {
            providerId: providerId,
            segmentIds: neededMissingSegments[providerId]
        };
        missingSegments.push(segmentProvider);
    });
    // if there is no misisng segments. return.
    if (missingSegments.length === 0) {
        return;
    }
    const segmentRequestId = requestContext.segmentRequestId;
    const missingSegmentResolvingUrl = `https://${domain}/_msdyn365/getsegment`;
    axios({
        method: 'post',
        url: missingSegmentResolvingUrl,
        data: {
            segmentProviderList: missingSegments,
            userId: userId,
            requestContext: requestContext,
            ...(segmentRequestId && { segmentRequestId: segmentRequestId })
        }
    })
        // after post request, oneRf will process the request. Node will not receive any response.
        .then()
        .catch(err => telemetry.log(LogLevel.Error, `Error in resolving segments from AJAX call for ${domain}`, { exception: err }));
};
